import { useState } from "react";

function loadScript(src) {
  return new Promise((resolve) => {
    const existingScript = document.querySelector(`script[src="${src}"]`);
    if (existingScript) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

export function useRazorpayPayment() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [paymentResponse, setPaymentResponse] = useState(null);

  const initiatePayment = async (options) => {
    try {
      setLoading(true);
      setError(null);

      const scriptLoaded = await loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
      );
      if (!scriptLoaded) throw new Error("Razorpay SDK failed to load");
      const rzp = new window.Razorpay({
        key: options?.razorpayKey,
        amount: options?.amount,
        currency: options.currency || "INR",
        callback_url: options.callbackUrl, // 🔹 optional
        order_id: options.orderId,
        name: options.name || "Puravankara",
        description: options.description || "Payment",
        prefill: options.prefill,
        notes: options.notes,
        theme: { color: options.themeColor || "#3399cc" },
        handler: function (response) {
        //  console.log("Payment Success:", response);
          setPaymentResponse(response); // store in hook state
        },
        modal: {
          ondismiss: () => {
            const originalAmount = options?.originalAmount;
            if (typeof options?.onFailure === "function") {
              options.onFailure(originalAmount);
            }
          },
        },
      });
      rzp.on("payment.failed", function (response) {
        console.error("Payment failed:", response.error);
        setError(response.error.description || "Payment failed");
        const originalAmount = options?.originalAmount;
        if (typeof options?.onFailure === "function") {
          options.onFailure(originalAmount);
        }
      });

      rzp.open();
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return { initiatePayment, loading, error, paymentResponse };
}
